import React, {useEffect, useState} from "react";
import {Container, Typography,} from "@mui/material";
import ClientForm from "../../components/ClientForm";
import {useNavigate, useParams} from "react-router-dom";
import {api} from "../../services/apiService";


export default function ClientEdit() {
    const params = useParams();
    const navigate = useNavigate();
    const [clientData, setClientData] = useState(null);

    const handleSubmit = (formData) => {
        const request = api.put("/clients/edit/" + params.id, formData)
            .then(() => {
                navigate("/clients/details/" + params.id);
            })
            .catch(error => {
                console.error("Error updating client:", error);
            });

        return request;
    }

    useEffect(() => {
        api.get("/clients/" + params.id)
            .then(response => {
                setClientData(response.data);
            })
            .catch(error => {
                console.error("Erreur lors de la récupération des détails du client:", error);
                setTimeout(() => {
                    navigate("/clients");
                }, 2000);
            });
    }, [params.id, navigate]);

    return (
        <Container maxWidth="xl">
            <Typography variant="h1" gutterBottom sx={{mb: 4}}>
                Modifier une fiche client
            </Typography>

            <ClientForm onSubmit={handleSubmit} data={clientData} editionMode={true}/>
        </Container>
    );
}

